var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainingDiaryNewEntry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#784ace;}.cls-2{fill:#d4bff6;}.cls-3{fill:#5735aa;}.cls-4{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "activity_training_diary_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300.95,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327.34,132.05v237.4a6.5,6.5,0,0,1-6.5,6.5H119.51V126a.46.46,0,0,1,.47-.46H320.84A6.5,6.5,0,0,1,327.34,132.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 119.4,
    y: 125.56,
    width: 33.37,
    height: 250.39
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "245.07 191.49 268.99 171.56 292.91 191.49 292.91 125.88 245.07 125.88 245.07 191.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M370,524.47a58.33,58.33,0,0,1-58.26-58.26V419.05H263.34a56.8,56.8,0,1,1,0-113.6H311.7V258.37a58.26,58.26,0,0,1,116.52,0v47.08h56.16a56.8,56.8,0,0,1,0,113.6H428.22v47.16A58.33,58.33,0,0,1,370,524.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370,215.11a43.39,43.39,0,0,1,43.26,43.26v62.08h71.16a41.8,41.8,0,0,1,0,83.6H413.22v62.16A43.39,43.39,0,0,1,370,509.47h0a43.39,43.39,0,0,1-43.26-43.26V404.05H263.34a41.8,41.8,0,1,1,0-83.6H326.7V258.37A43.39,43.39,0,0,1,370,215.11h0m0-30a73.34,73.34,0,0,0-73.26,73.26v32.08H263.34a71.8,71.8,0,1,0,0,143.6H296.7v32.16a73.26,73.26,0,0,0,146.52,0V434.05h41.16a71.8,71.8,0,0,0,0-143.6H443.22V258.37A73.34,73.34,0,0,0,370,185.11Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingDiaryNewEntry);
export default __webpack_public_path__ + "static/media/training_diary_new_entry.edc3f6983f79c277ba48fc4ff499c28f.svg";
export { ForwardRef as ReactComponent };